import React from 'react';

import { formatNumberWithSeparators } from 'tradera-utils/format';

const DiscountedPriceLabel = ({ className, price, tagName: TagName }) => {
    return (
        <TagName className={`text-function ${className || ''}`}>
            <del>{formatNumberWithSeparators(price)}</del>
        </TagName>
    );
};
DiscountedPriceLabel.defaultProps = {
    tagName: 'span'
};

export default DiscountedPriceLabel;
